import React from 'react';
import Input from 'components/Input';

const options = {
  'NOT_SYNC': 'Não sincronizado',
  'SYNC_TO_APP': 'Sincronizado para o app',
  'SYNC_FROM_APP': 'Sincronizado do app',
}

const NsirSyncStatusSelectV2 = ({ value }) => {
  return (
    <Input
      label="Status Sincronização"
      value={value ? options[value] : ""}
      disabled
    />
  );
}

export default NsirSyncStatusSelectV2;
